<template>
  <div>
    <p>
      <strong>
        <span v-if="printer.virtual === 't'" v-html="$t('printers.modal.confirmDeletePrinter.deleteWarningIndustrial')"></span>
        <span v-else>{{$t('printers.modal.confirmDeletePrinter.deleteWarning')}}</span>
        <span class="text-danger" v-if="canAccessAsOwner(this.printer.printer_ownership_id)">{{$t('printers.modal.confirmDeletePrinter.forAllUsers')}}</span>
        <span v-else>{{$t('printers.modal.confirmDeletePrinter.fromYourAccount')}}</span>
        {{$t('printers.modal.confirmDeletePrinter.confirmAction')}}
      </strong>
    </p>
    <p class="text-danger" v-if="canAccessAsOwner(this.printer.printer_ownership_id)">
      <br />
      {{$t('printers.modal.confirmDeletePrinter.ps')}}
      <strong v-if="isAdmin">{{$t('printers.modal.confirmDeletePrinter.psAdmin')}}</strong>
    </p>
    <br />
    <p>
      {{$t('printers.modal.confirmDeletePrinter.affectedPrinter')}}: <strong>{{calculatePrinterName(printer)}}</strong> - <strong>{{printer.description}}</strong>.
    </p>
    <br />
    <div v-if="printer.webcam_id > 0" class="delete-printer-live-view">
      <p>Affected printer live view:</p>
      <camera-live-view :printer-id="printer.printer_id"
                        :webcam-id="printer.webcam_id"
                        width="276"
                        height="207">
      </camera-live-view>
    </div>
    <div v-else class="delete-printer-live-view">
      <p>Affected printer live view:</p>
      <img width="276" height="207" src="https://acorn-cdn.azureedge.net/assets/i/liveview/no_camera.png">
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  import UserMixin from "@/mixins/user";
  import PrinterMixin from "@/mixins/printer";

  import CameraLiveView from "../camera/CameraLiveView";

  export default {
    name: 'delete-printer-confirmation',
    props: ['printer'],
    mixins: [PrinterMixin, UserMixin],
    components: {
      CameraLiveView
    },
    methods: {
      ...mapActions(['deletePrinter']),

      handleDeletePrinter() {
        this.deletePrinter(this.printer.printer_id).then(({data}) => {
          if (!data.result) {
            this.msgBoxOk(data.message);
          }
        }).catch(() => {
          this.msgBoxOk(this.$t('printers.modal.confirmDeletePrinter.errorDeletePrinter'));
        });
      }
    }
  }
</script>

<style scoped>
  .delete-printer-live-view {
    width: 100%;
    text-align: center;
  }
</style>